import type { FaireProductEntity } from "../../entity_types/product";

export const p_5z54o4ok: FaireProductEntity = {
  token: "p_5z54o4ok",
  type: "product",
  name: "Love You a Little Mower Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/9aec30d81ef833de624d5304fb94ed363137665a4d3fb996504e454e68931857/1549309072.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/b9313c8a842ff01d30f667579eb318a14b4591e5b706a8ee6b90fda8685ceef5/1528388189.png",
    "https://cdn.faire.com/fastly/74c80f290bfcbcaea676678334c1e0b5da864b81dbfa06bb3f56d816d19698af.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:22.599Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
